<template>
    <div v-show="isShow" :style="domStyle">
        <iframe :src="url" scrolling="auto" frameborder="0" style="width:100%;height:100%" ref="iframe"> 
        </iframe>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
export default {
    name : "fvUrlEmbed",
    props : ["primitives","fvSystemApi","parentObject"],
    created : function(){
        //组件数据混淆
        this.mixin(this.primitives);
        //组件大小位置初始化
        this.domStyle = {
            overflow: "hidden",
            position : "absolute",
            left : this.x + "px",
            top : this.y + "px",
            width : this.width + "px",
            height : this.height + "px"
        }
        this.enableStyle = {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0px",
            backgroundColor: "#ccbfbf",
            opacity: "0.5"
        }
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
    },
    data : function(){
        return {
            //是否可用
            isEnable : false,
            //是否显示
            isShow : true,
            //组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle : {},
            url: ""
        }
    },
    methods : {
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
        },
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            if(this.fontSize){
                this.$el.style.fontSize = parseInt(parseInt(this.fontSize.substr(0, this.fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + "px"; 
            }
            this.$el.style.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.$el.style.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + scaleObj.titleHeight + "px";
            this.$el.style.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.$el.style.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px"; 
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show : function(isShow){
            this.isShow = isShow ? true : false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable : function(isEnable){
            this.isEnable = isEnable ? true : false;
        },

        SetUrl : function(url,param){
            // if(url.indexOf('%.')!=-1){
            //     url=url.replace(/%./g,'/');
            // }
            if(url.indexOf("http") == -1){
                if(param){
                    this.url = "http://" + url + "?" + param;
                }else{
                    this.url = "http://" + url;
                }
            }else if(param != ""){
                // url = url.substring(url.indexOf(".")+2,url.lgenth);
                this.url =  url + "?" + param;
            }else{
                // url = url.substring(url.indexOf(".")+2,url.lgenth);
                this.url =   url ;
            };
        },

        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable : function(isEnable){
            this.isEnable = isEnable ? false : true;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/primitives/fvUrlEmbed/fvUrlEmbed.vue